package com.essntl.features.contact.ui

interface ContactNavigation {
    data class EditProposal(val proposalId: String) : ContactNavigation
    data class EditItinerary(val itineraryId: String) : ContactNavigation
}